/**
 *
 *	Common Utilities
 *
 */
import axios from "axios";
import link from "../pages/sampleData/link.json";
import { createMuiTheme } from "@material-ui/core/styles";


//for dev purposes on storybook - uncomment when deploying to live
// window._region = 'BR';

//consider moving these exports to config section
export const CDN_URI = window._region === 'BR' ?
  "https://z8games.akamaized.net/cfbr/templates/assets/" :
  "https://z8games.akamaized.net/cfna/templates/assets/";
export const CDN_URI_BASE = window._region === 'BR' ?
  "https://z8games.akamaized.net/cfbr/" :
  "https://z8games.akamaized.net/cfna/";

export const Tier_CDN_URI = window.CDN_URI;

export const _link = window._link || link;

export const profileAPI = window._region === 'BR' ?
"//br.crossfire.z8games.com/rest/userprofile.json" :
"//crossfire.z8games.com/rest/userprofile.json";

export const rankingAPI = window._region === 'BR' ?
"//br.crossfire.z8games.com/rest/eloranking.json?startrow=0&endrow=0" :
"//crossfire.z8games.com/rest/eloranking.json?startrow=0&endrow=0";

export const weaponsAPI = window._region === 'BR' ?
'//br.crossfire.z8games.com/rest/userweapons.json' :
'//crossfire.z8games.com/rest/userweapons.json';


export const headerAPI = profileAPI + "?command=header";

export const prefixURI = "/" + window.location.pathname.split("/")[1];

export const error404url = _link["url_crossfire_na"] + _link["error_404"];

export const pagePaths = {
  PROFILE_MANAGER: "profilemanager",
  RANKED_STATS: "rankedstats",
  ACHIEVEMENTS: "achievements",
  RIBBONS: "ribbons",
  COLLECTONS: "collections",
  INVENTORY: "inventory",
  MAIN: "",
  ERROR: "error",
};

export const mainPageAnchors = {
  OVERVIEW: {
    id: "overview",
    name: "Overview",
    URL: "",
    icon: "icon-overview"
  },
  CONTENT_CREATOR: {
    id: "content_creator",
    name: "Content Creator",
    URL: "",
    icon: "icon-videos"
  },
  MODE_STATS: {
    id: "mode_stats",
    name: "Mode Stats",
    URL: "",
    icon: "icon-mode"
  },
  RANKED_STATS: {
    id: "ranked_stats",
    name: "Ranked Stats",
    URL: "",
    icon: "icon-collection"
  },
  AWARDS: {
    id: "awards",
    name: "Awards",
    URL: "",
    icon: "icon-ribbons"
  },
  INVENTORY: {
    id: "inventory",
    name: "Inventory",
    URL: "",
    icon: "icon-inventory"
  }
};

export const hostingServices = [
  {
    name: "Imgur",
    url: "https://i.imgur.com/"
  }
];

//seems to be what kenichi wants - same as mui defaults except
//for xl
export const customMuiTheme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1420
    }
  }
});

export function showFooter() {
  if (document.getElementById("sgw-footer") != null) {
    document.getElementById("sgw-footer").style.display = "block";
  }
}

export function hideFooter() {
  if (document.getElementById("sgw-footer") != null) {
    document.getElementById("sgw-footer").style.display = "none";
  }
}

//hosting services is array of hosting services like the one
//above
export function isValidImgURL(url, hostingServices) {
  //need to incorporate all entries from hosting services
  //as part of regex - use reducer or something

  //hosting services escaped with the following
  //https://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
  let hostingServicesRegexPart = hostingServices
    .map(item => item.url.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"))
    .join("|");
  let regex = new RegExp(
    `^(${hostingServicesRegexPart}).*(\.jpg|\.png|\.gif)$`,
    "i"
  );

  return regex.test(url);
}

export function generatePageURI(pagePath = "") {
  return (
    "/" +
    window.location.pathname
      .split("/")
      .slice(1, 3)
      .join("/") +
    "/" +
    pagePath
  );
}

export function generatePage_no_USN_URI(pagePath) {
  return (
    "/" + window.location.pathname.split("/").splice(1, 1) + "/" + pagePath
  );
}

/**
 * Fast(est) method for getting a specific cookie value
 * http://stackoverflow.com/questions/5639346/what-is-the-shortest-function-for-reading-a-cookie-by-name-in-javascript
 *
 * @param {String} a
 * @returns {String}
 */
export function getCookieValue(a) {
  var b = document.cookie.match("(^|;)\\s*" + a + "\\s*=\\s*([^;]+)");
  return b ? b.pop() : "";
}

/**
 * Returns number using commas as thousands separator
 *
 * @param {Number} i
 */
export var numberWithCommas = x => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export function getImgurImageURL(url) {
  //imgur only
  // updated to be more forgiving since players are still pasting incorrectly
  // let imgur =  /https?:\/\/imgur\.com\/(.*?)(?:[#\/].*|$)/.exec(url);
  //console.log('start', url);

  let imgur = /https?:\/\/(i\.)?imgur\.com\/(.*?)(?:[#\/].*|$)/.exec(url);
  //console.table(imgur);
  if (imgur && imgur.length > 1 && imgur[2] !== "") {
    url = "https://i.imgur.com/" + imgur[2] + ".jpg";
  } else {
    url = "";
  }

  //console.log('end', url);
  return url;
}
/*
* getYouTubeID
* get the XXXXXX from the URL ->  https://www.youtube.com/watch?v=XXXXXX
// */
export function getYouTubeID(url) {
  var id = null;
  try {
    id = url.split("=")[1].trim();
    //console.log('checking youtube with ', url, id);
  } catch (e) {
    // nothing to say, probably recieved a no good URL
    //console.log(e)
  }
  return id;
}
/*
 * getTwitchID
 * get the XXXXXX from the URL ->  https://www.twitch.tv/videos/XXXXXX
 */
export function getTwitchID(url) {
  var id = null;
  try {
    var arr = url.split("/");
    id = arr[arr.length - 1].trim();
    //console.log('checking twitch with ', url, id);
  } catch (e) {
    // nothing to say, probably recieved a no good URL
    //console.log(e)
  }
  return id;
}

export function getStaticAchievementsList(callback) {
  const apilink = window._region === 'BR' ?
    "https://z8games.akamaized.net/cfbr/templates/assets/js/achievement_system_data.json" :
    "https://z8games.akamaized.net/cfna/templates/assets/js/achievement_system_data.json";

  var _this = this;

  axios
    .get(apilink)
    .then(function(response) {
      if (response.data) {
        //console.log('SUCCESS: retrieved all achievments data from CDN');
        //console.log(response.data);
        callback(response.data);
      } else {
        //console.log('FAIL: could not retrieve achievments description data from CDN');
        callback([]);
      }
    })
    .catch(function(error) {
      //console.log('Error: ' + error);
      callback([]);
    });
}

/**
 *
 * Create individual clan icon image string (for layering)
 *
 * for CFWE only
 */
export function createClanIconImageString(icon, position) {
  var assetDir = `${CDN_URI}imgs/ClanMark/`;

  var loc1 = assetDir + "BG_2/";
  var loc2 = assetDir + "line_2/";
  var loc3 = assetDir + "mark_2/";

  var prefix1 = "bg_";
  var prefix2 = "line_";
  var prefix3 = "";

  switch (position) {
    case 0:
      return loc1 + prefix1 + icon + ".png";
      break;
    case 1:
      return loc2 + prefix2 + icon + ".png";
      break;
    case 2:
      return loc3 + prefix3 + icon + ".png";
      break;
    default:
      return "";
      break;
  }
}

/**
 * GET the USN from the URL
 *
 */
export function getUSN() {
  // use the page to manually determine the route
  var my_route = window.location.pathname;
  var USN = "";

  var routes = my_route.split("/");

  if (routes.length >= 3) {
    USN = routes[2];
  }
  //console.log('USN is: ' + USN)
  // testing only
  return USN ? USN : "61471";
}

export function getcollectionID() {
  // use the page to manually determine the route
  var my_route = window.location.pathname;
  var ID = "";
  var routes = my_route.split("/");

  if (routes.length >= 4 && "collection" === routes[4]) {
    ID = routes[4];
  }
  // testing only
  return ID ? ID : 11; // why is 71 so troublesome?
}

//https://stackoverflow.com/questions/34097560/react-js-replace-img-src-onerror
//to be used in onError property of images; shows
//placeholder img located at argument for placeholderURL
export function handleMissingImg(placeholderURL) {
  return e => {
    e.target.onerror = null;
    e.target.src = placeholderURL;
  };
}

//https://stackoverflow.com/questions/822452/strip-html-from-text-javascript
export function stripHTML(html) {
  var tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}


export function seasonDisplayName(seasonNumber = null){

    let seasonDisplayText = null;
    const seasonNumStart = 30;
    const approxSeasonsPerYear = 3;
    const yearStart = 2025;
    const currentYear = new Date().getFullYear();

    if(seasonNumber){
        if(seasonNumber >=30){

            // 'year' text started at season 30, and I think there are 3/4 seasons so let's try to calcuate the text
            let yearStartDiff = currentYear - yearStart;
            //let seasonYearDisplay = Math.floor(yearStart + (seasonNumber-seasonNumStart)/seasonsPerYear);
            let seasonYearDisplay = yearStart + yearStartDiff;
            let subSeasonNum = 1 + (seasonNumber-seasonNumStart);

            if(yearStartDiff >= 1){
              let skipSeasons = approxSeasonsPerYear * yearStartDiff;
              subSeasonNum = Math.abs(seasonNumber-seasonNumStart-skipSeasons);
            }

            let seasonDisplay = seasonYearDisplay + '-' + subSeasonNum;
            seasonDisplayText = seasonDisplay;
        }else{
            seasonDisplayText = seasonNumber;
        }
    }
    return seasonDisplayText;
}

//may no no longer be needed - comment out and delete when
//ready
//get main page anchors data list - done here because this list
//is used in at least 2 components, so i want to keep the code
//DRY
// export function getMainPageAnchors(creator) {
// 	return  [
// 		{
// 			name: "Overview",
// 			URL: "",
// 			icon: "icon-overview"
// 		},
// 		...(creator ? [
// 			{
// 				name: "Content Creator",
// 				URL: "",
// 				icon: "icon-videos"
// 			}
// 		] : []),
// 		{
// 			name: "Mode Stats",
// 			URL: "",
// 			icon: "icon-mode"
// 		},
// 		{
// 			name: "Ranked Stats",
// 			URL: "",
// 			icon: "icon-collection"
// 		},
// 		{
// 			name: "Awards",
// 			URL: "",
// 			icon: "icon-ribbons"
// 		},
// 		{
// 			name: "Inventory",
// 			URL: "",
// 			icon: "icon-inventory"
// 		}
// 	];
// }
